<template>
  <div class="SingleColorSelector">
    <div class="p-lable">{{ propertyData[propertyDataKey].lable }}</div>
    <div class="p-singlecolorselector-wrap">
      <el-color-picker
        @change="handleChange"
        show-alpha
        popper-class="singlecolorselector"
        v-model="value"
      ></el-color-picker>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SingleColorSelector',
  /*  prop属性只读 不可直接修改 会影响性能以及维护性 */
  props: {
    CurrentConfigration: Object,
    propertyData: Object,
    propertyDataKey: String,
  },
  data() {
    return {
      value: '',
    };
  },
  mounted() {
    /* 获取初始值 */
    this.value = this.propertyData[this.propertyDataKey].value;
  },
  methods: {
    handleChange(val) {
      if (!val) {
        return;
      }
      /* 更新数据 */
      this.$store.commit('update_PropertyData', {
        key: this.propertyDataKey,
        value: val,
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.SingleColorSelector {
  width: 100%;
  box-sizing: border-box;
  .p-lable {
    box-sizing: border-box;
    padding: 0 15px;
    width: 100%;
    height: 30px;
    color: $property-title-color;
    font-size: $property-title-size;
    line-height: 30px;
  }
  .p-singlecolorselector-wrap {
    position: relative;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    width: 100%;
    height: 40px;
    padding: 0 15px;
  }
}
</style>
